module.exports = __webpack_public_path__ + "img/avatar.5d7d0bf2.png";